/* global modForm modUtils */
/**
 * function to save querystring into session storage.
 */
export function saveQueryParamsCookie() {
	const currentParams = modUtils.getUrlParamsToObject();
	if (currentParams && Object.keys(currentParams).length && window.sessionStorage && !modForm.opts.ignoreQueryParamsInSessionStorage) {
		window.sessionStorage.setItem('queryParams', JSON.stringify(currentParams));
	}
}
